import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import NebulaModuleBase from './module-base';
export var UPNetworkConfigPlugin = function (_NebulaModuleBase) {
    _inherits(UPNetworkConfigPlugin, _NebulaModuleBase);

    function UPNetworkConfigPlugin() {
        _classCallCheck(this, UPNetworkConfigPlugin);

        return _possibleConstructorReturn(this, (UPNetworkConfigPlugin.__proto__ || Object.getPrototypeOf(UPNetworkConfigPlugin)).apply(this, arguments));
    }

    _createClass(UPNetworkConfigPlugin, [{
        key: 'turnOnSwitch',
        value: function turnOnSwitch(protocolType) {
            var param = {
                protocolType: protocolType
            };
            return this.generatePromiseByFunctionWithParams('TurnOnSwitchForNetworkConfigPlugin', param);
        }
    }, {
        key: 'isSwitchEnable',
        value: function isSwitchEnable(protocolType) {
            var param = {
                protocolType: protocolType
            };
            return this.generatePromiseByFunctionWithParams('IsSwitchEnableForNetworkConfigPlugin', param);
        }
        // jumpToSettingPage(protocolType: number): Promise<Result<boolean>> {
        //   let param = {
        //     protocolType: protocolType,
        //   };
        //   return this.generatePromiseByFunctionWithParams<boolean>('JumpToSettingPageForNetworkConfigPlugin', param);
        // }

    }, {
        key: 'connectByWiFiInfo',
        value: function connectByWiFiInfo(wiFiInfo) {
            return this.generatePromiseByFunctionWithParams('ConnectWiFiForNetworkConfigPlugin', wiFiInfo);
        }
        // getNetworkConfigurableInfo(): Promise<Result<NetworkBaseInfo>> {
        //   return this.generatePromiseByFunctionWithParams<NetworkBaseInfo>(
        //     'GetNetworkConfigurableInfoForNetworkConfigPlugin', null);
        // }

    }, {
        key: 'getWiFiList',
        value: function getWiFiList() {
            return this.generatePromiseByFunctionWithParams('GetWiFiListForNetworkConfigPlugin', null);
        }
    }, {
        key: 'isDeviceHotspot',
        value: function isDeviceHotspot(ssid) {
            var param = {
                ssid: ssid
            };
            return this.generatePromiseByFunctionWithParams('IsDeviceHotspotForNetworkConfigPlugin', param);
        }
        // startBleScan(listener: (result: BleScanResult) => void): Promise<Result<void>> {
        //   let event = 'OnBleScan';
        //   let param = {
        //     eventName: event,
        //   };
        //   return this.generatePromiseByAttachListenerWithParams<void>(event, listener,
        //     'StartBleScanForNetworkConfigPlugin', param);
        // }
        // stopBleScan(listener: (result: BleScanResult) => void): Promise<Result<void>> {
        //   let event = 'OnBleScan';
        //   let param = {
        //     eventName: event,
        //   };
        //   return this.generatePromiseByDetachListenerWithParams<void>(event, listener,
        //     'StopBleScanForNetworkConfigPlugin', param);
        // }

    }, {
        key: 'getRouterIPAddress',
        value: function getRouterIPAddress() {
            return this.generatePromiseByFunctionWithParams('GetRouterIPAddressForNetworkConfigPlugin', null);
        }
    }, {
        key: 'isNetworkConnected',
        value: function isNetworkConnected() {
            return this.generatePromiseByFunctionWithParams('IsNetworkConnectedForNetworkConfigPlugin', null);
        }
    }, {
        key: 'isOnlineNet',
        value: function isOnlineNet() {
            return this.generatePromiseByFunctionWithParams('IsOnlineNetForNetworkConfigPlugin', null);
        }
        // addNetworkConnectChangeListener(listener: (data: NetworkConnectChangeResult) => void): Promise<Result<void>> {
        //   let event = 'OnNetworkConnectChange';
        //   let param = {
        //     eventName: event,
        //   };
        //   return this.generatePromiseByAttachListenerWithParams<void>(event, listener,
        //     'AddNetworkConnectChangeListenerForNetworkConfigPlugin', param);
        // }
        // removeNetworkConnectChangeListener(listener: (data: NetworkConnectChangeResult) => void): Promise<Result<void>> {
        //   let event = 'OnNetworkConnectChange';
        //   let param = {
        //     eventName: event,
        //   };
        //   return this.generatePromiseByDetachListenerWithParams<void>(event, listener,
        //   'RemoveNetworkConnectChangeListenerForNetworkConfigPlugin', param);
        // }

    }, {
        key: 'setWiFiInfo',
        value: function setWiFiInfo(wiFiInfo) {
            return this.generatePromiseByFunctionWithParams('SetWiFiInfoForNetworkConfigPlugin', wiFiInfo);
        }
    }, {
        key: 'getCacheWiFiListBySsid',
        value: function getCacheWiFiListBySsid(ssid) {
            var param = {
                ssid: ssid
            };
            return this.generatePromiseByFunctionWithParams('GetCacheWiFiListForNetworkConfigPlugin', param);
        }
    }, {
        key: 'fetchConfigRouterInfo',
        value: function fetchConfigRouterInfo() {
            return this.generatePromiseByFunctionWithParams('GetConfigRouterInfoForNetworkConfigPlugin', null);
        }
    }]);

    return UPNetworkConfigPlugin;
}(NebulaModuleBase);